import FlashLib from "flashlib";
import RelaxModel from "Base/model/RelaxModel";

export default class BaseAutoPlayPopupContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.changeWindow(1);
        this.hide();
    }

    init() {

    }

    changeWindow(value) {
        if (!value) {
            value = this.currentFrameIndex === 1 ? 2 : 1
        }
        /*if (RelaxModel.availableAutoPlayStates.indexOf(value) === -1) {
            value = RelaxModel.availableAutoPlayStates[0];
            if (this.switchButton) {
                this.switchButton.visible = false;
            }
        }*/

        this.goToFrame(value);

        if (this.switchButton) {
            this.switchButton.off('pointertap', this.onSwitchButtonTap, this);
        }

        this.switchButton = this.getChildByName('switchButton');
        this.switchButton.interactive = true;
        this.switchButton.buttonMode = true;
        this.switchButton.on('pointertap', this.onSwitchButtonTap, this);
        this.switchButton.goToFrame(this.currentFrameIndex);
        this.switchButton.visible = false;

        this.autoplayCountContainer = this.getChildByName('autoPlayCountContainer');
        this.autoplayCountContainer.setMode(value);
    }

    onSwitchButtonTap() {
        this.changeWindow();
    }

    switch() {
        if (this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        this.changeWindow(1);
        //this.autoplayCountContainer.reset();
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }
}